<script>
import NotificacoesService from 'services/notificacoes-usuario.service';
import VisualizarNotificacoesDialog from "views/post-login/participante/VisualizarNotificacoesDialog.vue";
import { Dialog } from "commons/classes/dialog";

export default {
  name: "ListarNotificacoesView",
  components: { VisualizarNotificacoesDialog },
  mixins: [NotificacoesService],
  data() {
    return {
      form: {
        filters: {
          assunto: null,
          dataInicio: null,
          dataFim: null,
          lida: null,
        },
        lists: {
          status: [
            { nome: 'Lida', value: true },
            { nome: 'Não lida', value: false },
          ]
        }
      },
      table: {
        itens: [],
        headers: [
          { text: 'Assunto da Notificação', align: 'center', value: 'assunto' },
          { text: 'Data da Notificação', align: 'center', value: 'dataNotificacao' },
          { text: 'Status', align: 'center', value: 'lida' },
          { text: 'Ações', align: 'center', value: 'acoes', sortable: false },
        ],
      },
      dialogVisualizarNotificacao: Dialog.Build(),
    }
  },
  computed: {
    payload() {
      return {
        params: {
          ...this.form.filters,
          dataInicio: this.$formatarDateParaEnviar(this.form.filters.dataInicio),
          dataFim: this.$formatarDateParaEnviar(this.form.filters.dataFim),
          lida: this.form.filters.lida,
        },
      }
    }
  },
  methods: {
    async buscarNotificacoes() {
      const { data } = await this.$buscarNotificacoes(this.payload);
      this.table.itens = data.itens;
    },
    resetForm() {
      this.form.filters = {
        assunto: null,
        dataInicio: null,
        dataFim: null,
        lida: null,
      };
      this.table.itens = [];
    },
    async openDialogVisualizarNotificacao(id) {
      try {
        const [{ data },] = await Promise.all([
          this.$visualizarNotificacao(id),
          this.$marcarNotificacaoComoLida(id)
        ]);

        this.dialogVisualizarNotificacao.open(data.item)

      } catch {
        console.log('erro')
      }
    },
    async excluirNotificacao(id) {
      await this.$swal({
        text: 'Deseja confirmar a exclusão da notificação?',
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar'
      })

      await this.$excluirNotificacao(id)
      this.$notifySuccess("Operação realizada com sucesso.")
      await this.buscarNotificacoes()
    },

    async onCloseDialogNotificao() {
      await this.buscarNotificacoes()
      this.dialogVisualizarNotificacao.close()
    }
  },
}
</script>

<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form" @submit.prevent="buscarNotificacoes">
        <v-row class="justify-center mt-3">
          <v-col cols="3">
            <v-text-field v-model="form.filters.assunto" label="Assunto da Notificação" outlined dense></v-text-field>
          </v-col>
          <sigfoco-date-picker :cols="2" label="Data Início" v-model="form.filters.dataInicio" removeIcon outlined
            dense></sigfoco-date-picker>
          <sigfoco-date-picker :cols="2" label="Data Final" v-model="form.filters.dataFim" removeIcon outlined
            dense></sigfoco-date-picker>
          <v-col cols="2">
            <v-select v-model="form.filters.lida" label="Status" :items="form.lists.status" item-text="nome"
              item-value="value" outlined dense></v-select>
          </v-col>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sigfoco-submit-button></sigfoco-submit-button>
            <sigfoco-tooltip :text="'Limpar'" :icon="'mdi-eraser'" @click="resetForm()"></sigfoco-tooltip>
          </v-col>
        </div>
      </v-form>

      <v-data-table class="mt-5" :headers="table.headers" :items="table.itens" :items-per-page="10"
        :footer-props="$footerProps">
        <template v-slot:[`item.lida`]="{ item }">
          <span>{{ item.lida ? 'Lida' : 'Não Lida' }}</span>
        </template>
        <template v-slot:[`item.dataNotificacao`]="{ item }">
          <span>{{ $formatarData(item.dataNotificacao) }}</span>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sigfoco-tooltip text="Visualizar" icon="mdi-eye" small
            @click="openDialogVisualizarNotificacao(item.id)"></sigfoco-tooltip>
          <sigfoco-tooltip text="Excluir" icon="mdi-delete" small
            @click="excluirNotificacao(item.id)"></sigfoco-tooltip>
        </template>
      </v-data-table>

      <VisualizarNotificacoesDialog :visible="dialogVisualizarNotificacao.visible"
        :content="dialogVisualizarNotificacao.content" @onClose="onCloseDialogNotificao" />
    </v-container>
  </div>
</template>